import { forwardRef, Ref } from 'react';
import { PieChart, Pie, Cell } from 'recharts';
import styles from './GutCstPieChart.module.css';
import { getGutMicrobiomeColor } from '@repo/utils';

export interface GutCstPieChartData {
  name: string;
  value: number | null;
}

interface GutCstPieChartProps {
  gutVaginalTypePieData: GutCstPieChartData[];
  userValueFormat: (value: number, format: string) => string;
}

export const GutCstPieChart = forwardRef(function GutCstPieChart(
  { gutVaginalTypePieData, userValueFormat }: GutCstPieChartProps,
  ref: Ref<HTMLDivElement> | null,
) {
  const validData = gutVaginalTypePieData?.filter(
    d => d.value !== null && d.value !== undefined,
  );

  return (
    <div ref={ref} className={styles.container}>
      {!gutVaginalTypePieData.length ? (
        <div></div>
      ) : (
        <PieChart width={140} height={140} className={styles.pieChart}>
          <Pie
            data={gutVaginalTypePieData}
            dataKey='value'
            innerRadius={56}
            outerRadius={70}
            blendStroke
            isAnimationActive={false}
          >
            {gutVaginalTypePieData.map((entry, index) => (
              <Cell
                key={`gut-type-cell-${index}`}
                fill={getGutMicrobiomeColor(entry.name)}
              />
            ))}
          </Pie>
        </PieChart>
      )}
      <div className={styles.legend}>
        {validData.map((pieData, idx) => (
          <div className={styles['legend-row']} key={`legend-${idx}`}>
            <div className={styles['legend-row-label']}>
              <div
                className={styles.square}
                style={{
                  backgroundColor: getGutMicrobiomeColor(pieData.name),
                }}
              ></div>
              <div className='f5'>{pieData.name}</div>
            </div>
            <div className={`f5 text-right text-grey`}>
              {userValueFormat(pieData.value ?? 0, 'percent')}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});
